export default __webpack_public_path__ + "static/media/avatar.af6eccf9.png";